pageLoad('animes_screenshots', () => {
  $('.c-screenshot').magnificRelGallery();
});
